define('TescoMobile_CheckoutCareHub/js/catalog-add-to-cart-mixin',['jquery', 'mage/translate', 'Magento_Ui/js/modal/confirm'], function ($, $t, confirmModal) {
  'use strict';

  const mixin = {
    dfwConfirmed: false,
    ajaxSubmit: function (form) {
      let self = this,
        formData;
      if (form) {
        formData = new FormData(form[0]);
        if (!formData.has('tm_deliver_from_warehouse') || parseInt(formData.get('tm_deliver_from_warehouse')) !== 1) {
          return this._super(form);
        }
      }
      if (this.dfwConfirmed) {
        return this._super(form);
      }
      $('body').trigger('dl-modal-delivered-from-warehouse');
      confirmModal({
        title: $t('Are you sure you want this order to be delivered from warehouse?'),
        content: $t("If you have stock available in store, please go back and uncheck 'Deliver from warehouse'."),
        modalClass: 'confirm-popup',
        clickableOverlay: false,
        actions: {
          cancel: function () {
            $('body').loader('hide');
            self.enableAddToCartButton(form);
          },
          confirm: function () {
            self.dfwConfirmed = true;
            $('body').trigger('dl-modal-delivered-from-warehouse-selected');
            self.ajaxSubmit(form);
          }
        },
        buttons: [{
          text: $.mage.__('Back'),
          class: 'action secondary',
          click: function (event) {
            this.closeModal(event, false);
          }
        }, {
          text: $.mage.__('Continue'),
          class: 'action primary',
          click: function (event) {
            this.closeModal(event, true);
          }
        }]
      });
    },
    enableAddToCartButtonNoAdded: function (form) {
      this.dfwConfirmed = false;
      return this._super(form);
    }
  };
  return function (widget) {
    $.widget('mage.catalogAddToCart', widget, mixin);
    return $.mage.catalogAddToCart;
  };
});

